import React from 'react';
import { User } from 'lucide-react';
export function EmailTestimonial() {
  return <div className="my-16 bg-[#EFF6FF] p-8 md:p-10 rounded-xl border border-blue-100 shadow-sm" data-id="element-99">
      <div className="flex items-center mb-8 border-b border-blue-200 pb-6" data-id="element-100">
        <div className="w-12 h-12 bg-blue-200 rounded-full flex items-center justify-center text-blue-600 mr-4" data-id="element-101">
          <User size={24} data-id="element-102" />
        </div>
        <div data-id="element-103">
          <div className="font-bold text-gray-900 text-lg" data-id="element-104">Jessica</div>
          <div className="text-xs text-gray-500 font-medium" data-id="element-105">aan mij</div>
        </div>
      </div>

      <div className="text-gray-800 leading-relaxed space-y-5 text-lg" data-id="element-106">
        <p data-id="element-107">Hi Amee,</p>
        <p data-id="element-108">Super, het is gelukt. Dankjewel!</p>
        <p data-id="element-109">
          Ik wilde nog mijn complimenten geven voor de masterclass van gisteren.
          Ik heb menig gratis webinars gevolgd en vond die van jou echt wel de
          beste. Ben benieuwd naar de cursussen!
        </p>
        <p data-id="element-110">Groeten, Jessica</p>
      </div>
    </div>;
}